/**
 * Sentry integration for logger. If you set up sentry integration in your app, and provide the
 * client instance to logger, logger will mirror every logger.error call to Sentry.
 */
var instance = null;
/**
 * Provide logger with your app's environment specific Sentry client instance. This instance will be
 * used to log errors to Sentry.
 * @param sentryInstance
 */

export var setSentryClient = function setSentryClient(sentryInstance) {
  instance = sentryInstance;
};
/**
 * If Sentry is initialised for your app, this will call Sentry.captureException for each of the
 * messages supplied.
 *
 * Folks might call logger.error with strings in addition to error objects (like say
 * `log.error('something went wrong', err)`. This would cause us to capture two exceptions even
 * though one is enough and the first one is probably noise AFA a sentry dashboard is concerned).
 * We will revisit this decision if we find too much noise being generated.
 */

export var logToSentry = function logToSentry() {
  if (instance) {
    for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
      messages[_key] = arguments[_key];
    }

    messages.forEach(function (message) {
      if (message instanceof Error) {
        instance.captureException(message);
      } else {
        // Need to try this with different types.
        instance.captureException(new Error(message));
      }
    });
  }
};